module.exports = __webpack_public_path__ + "img/nether.44703e1e.png";